import { toast } from "vanilla-sonner";

export function FormAsync(): void {
  async function onSubmit(this: HTMLFormElement, e: SubmitEvent) {
    e.preventDefault();
    const submit = this.querySelector<HTMLButtonElement>("[form-async-submit]");
    if (!submit || submit.ariaDisabled === "true") {
      return;
    }

    const SubmitInnerHTMLBuffer = submit.innerHTML;
    const feedbackSuccessElement = this.querySelector<HTMLButtonElement>("[form-async-feedback-success]");
    const feedbackErrorElement = this.querySelector<HTMLButtonElement>("[form-async-feedback-error]");

    const feedbackSuccess = feedbackSuccessElement?.innerHTML ? feedbackSuccessElement.innerHTML : "Mensagem enviada com sucesso.";
    const feedbackError = feedbackErrorElement?.innerHTML
      ? feedbackErrorElement.innerHTML
      : "Ops, tivemos um problema, ao enviar o formulário.";

    let body = new FormData(this);
    const beforeSubmit = this.getAttribute("form-async-before-submit");
    if (beforeSubmit && typeof window[beforeSubmit as keyof Window] === "function") {
      body = window[beforeSubmit as keyof Window](body);
    }

    submit.ariaDisabled = "true";
    submit.innerHTML = "Enviando...";
    submit.classList.add("form-async-submit-sending");

    try {
      const response = await fetch(this.action, {
        method: this.method,
        body,
        headers: {
          "X-Requested-With": "XMlHttpRequest",
          Accept: "application/json",
        },
      });
      let onSuccess = null;
      switch (true) {
        case response.status === 422: {
          const bodyResponse = await response.json();
          let errMessage = "";
          for (const key in bodyResponse.errors) {
            if (Object.hasOwn(bodyResponse.errors, key)) {
              errMessage = bodyResponse.errors[key].shift();
              break;
            }
          }
          toast.warning(errMessage, { duration: 15000 });
          break;
        }
        case response.status >= 400:
          toast.error(feedbackError, { duration: 15000 });
          break;
        default:
          onSuccess = this.getAttribute("form-async-success");
          toast.success(feedbackSuccess);
      }

      if (onSuccess && typeof window[onSuccess as keyof Window] === "function") {
        window[onSuccess as keyof Window]();
      }
    } catch (reason) {
      console.error(reason);
    }
    submit.innerHTML = SubmitInnerHTMLBuffer;
    submit.ariaDisabled = "false";
    submit.classList.remove("form-async-submit-sending");
  }

  document.querySelectorAll<HTMLFormElement>("[form-async]").forEach((form) => {
    form.addEventListener("submit", onSubmit);
    const feedbackSuccessElement = form.querySelector<HTMLButtonElement>("[form-async-feedback-success]");
    if (feedbackSuccessElement) {
      feedbackSuccessElement.style.display = "none";
    }
    const feedbackErrorElement = form.querySelector<HTMLButtonElement>("[form-async-feedback-error]");
    if (feedbackErrorElement) {
      feedbackErrorElement.style.display = "none";
    }
  });
}
